var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseWithDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.480469L0.666672 14.4805L2.68334 17.1305L5.66667 14.8471V30.4805H32.3333V14.8471L35.3167 17.1138L37.3333 14.4805L19 0.480469ZM29 27.1471H9V12.3138L19 4.68047L29 12.3138V27.1471ZM14 18.8138C14 19.7305 13.25 20.4805 12.3333 20.4805C11.4167 20.4805 10.6667 19.7305 10.6667 18.8138C10.6667 17.8971 11.4167 17.1471 12.3333 17.1471C13.25 17.1471 14 17.8971 14 18.8138ZM19 17.1471C19.9167 17.1471 20.6667 17.8971 20.6667 18.8138C20.6667 19.7305 19.9167 20.4805 19 20.4805C18.0833 20.4805 17.3333 19.7305 17.3333 18.8138C17.3333 17.8971 18.0833 17.1471 19 17.1471ZM24 18.8138C24 17.8971 24.75 17.1471 25.6667 17.1471C26.5833 17.1471 27.3333 17.8971 27.3333 18.8138C27.3333 19.7305 26.5833 20.4805 25.6667 20.4805C24.75 20.4805 24 19.7305 24 18.8138Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseWithDots);
export default __webpack_public_path__ + "static/media/house_with_dots.af00d047e95c99ad3e7c3711a4887253.svg";
export { ForwardRef as ReactComponent };